<script>
import httpClient from "@/bundles/http-client";
import route from "@/bundles/route";
import Toolbox from "@/shared/toolbox";

export default {
    name: "GoogleBtnV2",
    props: {
        clientId: {
            type: String,
            required: true,
        },
        context: {
            type: String,
            default: 'signin',
        },
    },
    data: () => ({
        apiLoaded: false,
        apiLoadInitialized: false,
    }),
    methods: {
        loadGSI() {
            return new Promise((resolve, reject) => {
                if (window.google) {
                    resolve(window.google);
                } else if (!this.apiLoadInitialized) {
                    const script = document.createElement("script");
                    this.apiLoadInitialized = true;

                    script.addEventListener("load", () => {
                        this.apiLoaded = true;
                        resolve(window.google);
                    });

                    script.addEventListener("error", () => {
                        reject("Failed to load the GSI JavaScript Library.");
                    });

                    script.src = 'https://accounts.google.com/gsi/client';
                    script.async = true;
                    script.defer = true;

                    document.head.appendChild(script);
                }
            });
        },
        handleResponse(gsiResponse) {
            httpClient.postCsrf(route('login-gsi'), gsiResponse).then((response) => {
                if (response.data.id) {
                    this.$emit('loggedIn');
                } else if (response.data.error) {
                    Toolbox.error(response.data.error);
                } else {
                    console.debug(response.data);

                    const registryData = response.data;
                    registryData.credential = gsiResponse.credential;

                    this.id = false;
                    this.$emit('registry', false); //Return whether registered
                    this.$emit('registryData', registryData); //Return whether registered
                }
            });
        },
    },
    computed: {
        isCustomLink() {
            return typeof this.$slots.default !== 'undefined';
        },
    },
    mounted() {
        this.loadGSI().then((google) => {
            google.accounts.id.initialize({
                client_id: this.clientId,
                callback: this.handleResponse,
                context: this.context,
                ux_mode: 'popup',
                allowed_parent_origin: window.location.origin,
            });

            // google.accounts.id.prompt();

            google.accounts.id.renderButton(this.isCustomLink ? this.$refs.hiddenContainer : this.$refs.container, {
                type: "standard",
                shape: "rectangular",
                theme: "outline",
                text: this.context === 'signup' ? 'signin_up' : 'signin_with',
                size: "large",
                locale: "en-US",
                logo_alignment: "center",
                width: this.$refs.container.offsetWidth,
            });

            if (this.isCustomLink) {
                this.$slots.default[0].elm.addEventListener('click', () => {
                    console.log('Opening Google login prompt...');

                    const gsiBtn = this.$refs.hiddenContainer.querySelector('[role="button"]');
                    gsiBtn.click();
                });
            }
        }, (reason) => {
            console.error(reason);

            Toolbox.error('Error loading the "Login with Google" functionality.');
        });
    },
    emits: ['registry', 'registryData', 'loggedIn']
}
</script>

<template>
    <div class="login-with-google" :class="{'custom-link': isCustomLink, 'button-container': !isCustomLink}" ref="container">
        <slot>
        </slot>
        <div ref="hiddenContainer" class="d-none"></div>
    </div>
</template>

<style scoped>
    .login-with-google.button-container {
        margin-top: 12px;
    }

    .login-with-google.custom-link {
        display: inline;
    }
</style>
